import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import { auth } from '@configs/firebase'
import axios from 'axios'
import Cookies from 'js-cookie'

/**
 * Returns a valid auth token. The cookie can hold a stale (expired) Firebase
 * ID token on a fresh load until onAuthStateChanged refreshes it, which causes
 * 401s. So when a Firebase user is present we ask Firebase for the token
 * (it auto-refreshes if expired) and keep the cookie in sync; otherwise we
 * fall back to the cookie (e.g. Firebase not yet initialised).
 */
const getValidToken = async (): Promise<string | undefined> => {
  try {
    if (auth?.currentUser) {
      const freshToken = await auth.currentUser.getIdToken()
      if (freshToken) {
        Cookies.set(AUTH_TOKEN_KEY, freshToken)
        return freshToken
      }
    }
  } catch {
    // fall through to the cookie value
  }
  return Cookies.get(AUTH_TOKEN_KEY)
}

export const FETCH_WITH_TOKEN = async (url: string, isPublic = false) => {
  const token = await getValidToken()
  if (!token && !isPublic) {
    throw new Error('Authentication failed!')
  }
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  const response = await axios.get(url, config)

  return response.data
}

export const FETCH_WITH_HEADERS = async (url: string) => {
  const tokenId = Cookies.get(AUTH_TOKEN_KEY)
  const config = {
    headers: {
      Authorization: `Bearer ${tokenId}`,
    },
  }
  try {
    const response = await axios.get(url, config)

    const { data, headers } = response

    return { data, headers: headers as any }
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || 'Network response was not ok'
    )
  }
}
